<template>
  <div>
    <subscriberView
      v-if="subscriberView == true"
      :uid="this.usersub"
      :user="this.currentUser"
      @getcurrentuser="getCurrentUser"
    />
    <superAdminView
      :uid="this.usersub"
      :user="this.currentUser"
      v-if="superAdmin == true"
    />
    <agencyView
      :uid="this.usersub"
      :user="this.currentUser"
      v-if="agencyView == true"
      @getcurrentuser="getCurrentUser"
    />
    <agencySalesView
      :uid="this.usersub"
      :user="this.currentUser"
      v-if="agencySales == true"
      @getcurrentuser="getCurrentUser"
    />
    <resellerView
      :uid="this.usersub"
      :user="this.currentUser"
      v-if="reseller == true"
      @getcurrentuser="getCurrentUser"
    />
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="120"
        >Please Wait...</v-progress-circular
      >
    </v-overlay>
  </div>
</template>

<script>
import agencySalesView from "../components/userviews/agencySalesView.vue";
// import subscriberView from "../components/userviews/subscriberView.vue";
import subscriberView from '../components/userviews/subscriberView.vue'
import agencyView from "../components/userviews/agencyView.vue";
import superAdminView from "../components/userviews/superAdminView.vue";
import resellerView from "../components/userviews/resellerView.vue";

import { getAuth, signOut } from "firebase/auth";
import { firebaseApp } from "../firebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
const db = getFirestore(firebaseApp);

export default {
  components: {
    subscriberView,
    agencyView,
    superAdminView,
    agencySalesView,
    resellerView,
  },

  data: () => ({
    agencyView: false,
    subscriberView: false,
    superAdmin: false,
    agencySales: false,
    reseller: false,
    usersub: "",
    currentUser: "",
    overlay: false,
  }),

  created() {
    this.getCurrentUser();
  },

  methods: {
    getCurrentUser() {
      this.overlay = true;
      const auth = getAuth(firebaseApp);
      const user = auth.currentUser;
      user
        .getIdTokenResult()
        .then(async (idTokenResult) => {
          let userClaims = idTokenResult.claims.UserRole;
          this.usersub = idTokenResult.claims.user_id;
          const docRef = doc(db, "users", this.usersub);
          const docSnap = await getDoc(docRef);
          this.currentUser = docSnap.data();

          console.log('getCurrentUser', this.currentUser)

          if (this.currentUser.isActive == true) {
            this.$store.commit("setUser", this.currentUser);
            this.getUserView(userClaims);
          } else if (this.currentUser.isActive == false) {
            this.logout();
          }
        })
        .catch((error) => {
          console.log(error);
          this.overlay = false;
        });
    },

    async getUserView(userClaims) {
      if (userClaims === "Agency Admin") {
        this.agencyView = true;
      } else if (userClaims === "Social Marketing Manager") {
        this.agencyView = true;
      } else if (userClaims === "Subscriber") {
        this.subscriberView = true;
      } else if (userClaims === "Super Admin") {
        this.superAdmin = true;
      } else if (userClaims === "Agency Sales") {
        this.agencySales = true;
      } else if (userClaims === "Reseller") {
        this.reseller = true;
      }
      this.overlay = false;
    },

    logout() {
      const auth = getAuth(firebaseApp);
      signOut(auth)
        .then(() => {
          this.$router.replace("/login");
          alert("You done have permissions any more");
        })
        .catch((error) => {
          alert(error);
        });
    },
  },
};
</script>

<style>
/* .theme--light.v-tabs > .v-tabs-bar {
  background-color: #3d6eb1 !important;
} */
</style>
